import React from 'react';
import {useStore} from "@/app/providers/StoreProvider";
import ImgGoldPuck from '@/shared/pictures/gold_puck.png';
import {observer} from "mobx-react-lite";

export const ProfileGoldPuckWidget = observer(() => {
    const {userStore} = useStore();
    const { gameInfo } = userStore;
    return (
        <div className='gold-puck'>
            <div className='gold-puck-item'>
                <h3 className='gold-puck-item_title'>Золотые шайбы: <span>{gameInfo.user.goldenScore}</span></h3>
                <img className='gold-puck-item_img' src={ImgGoldPuck} alt="puck"/>
            </div>
        </div>
    );
});

